<!-- zhangziao -->
<template>
    <div class="w100">
        <article class="wContent center" style="padding: 10px 0 20px 0">
            <el-row :gutter="20">
                <el-col :span="16">
                    <div class="grid-content">
						<el-menu :default-active="default_active" class="el-menu-demo" mode="horizontal" @select="handleSelectMenu1">
						    <el-menu-item :index="'A_'+index" v-for="(item, index) in productTag_list">{{item.basePriceName.substr(0, item.basePriceName.indexOf('全'))}}</el-menu-item>
						</el-menu>
						<el-menu default-active="B_0" class="el-menu-demo" mode="horizontal" @select="handleSelectMenu2">
						    <el-menu-item index="B_0">价格</el-menu-item>
                            <!-- <el-menu-item index="B_1">库存</el-menu-item>
							<el-menu-item index="B_2">成本</el-menu-item>
							<el-menu-item index="B_3">供求</el-menu-item> -->
						</el-menu>
						<el-menu :default-active="activeMenuIndex3" class="el-menu-demo" mode="horizontal" @select="handleSelectMenu3">
						    <el-menu-item index="C_0" v-show="scj_show">市场价</el-menu-item>
							<el-menu-item index="C_1" v-show="ccj_show">出厂价</el-menu-item>
							<el-menu-item index="C_2" v-show="jsj_show">结算价</el-menu-item>
							<el-menu-item index="C_3" v-show="cgj_show">采购价</el-menu-item>
							<el-menu-item index="C_4" v-show="zdj_show">指导价</el-menu-item>
							<el-menu-item index="C_5" v-show="gkxhj_show">港口现货价</el-menu-item>
						</el-menu>
						<template>
							<template v-if="count=='202'">
								<el-table :data="tableData" :header-cell-style="{'color':'#333333','font-weight':'700','background-color': '#f5fafe'}" style="font-size: 14px;" v-loading="loading" element-loading-text="加载中" element-loading-spinner="el-icon-loading">
									<el-table-column prop="typeName" label="分类"></el-table-column>
									<el-table-column prop="productName" label="品种"></el-table-column>
									<el-table-column prop="standard" label="规格"></el-table-column>
									<el-table-column prop="price" label="结算价格"></el-table-column>
									<el-table-column prop="priceAdd" label="结算承兑加价"></el-table-column>
									<el-table-column prop="guidingPrice" label="指导价格"></el-table-column>
									<el-table-column prop="guidingPriceAdd" label="结算价格承兑加价"></el-table-column>
									<el-table-column prop="settlementMode" label="结算方式"></el-table-column>
									<el-table-column prop="dataDate" label="日期"></el-table-column>
								</el-table>
								<el-pagination style="margin-top: 20px;" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="current_page" :page-size="page_num" layout="total, prev, pager, next, jumper" :total="total_num"></el-pagination>
							</template>
							<template v-else-if="count=='002'||count=='102'||count=='302'">
								<el-table :data="tableData" :header-cell-style="{'color':'#333333','font-weight':'700','background-color': '#f5fafe'}" style="font-size: 14px;" v-loading="loading" element-loading-text="加载中" element-loading-spinner="el-icon-loading">
									<el-table-column prop="typeName" label="分类"></el-table-column>
									<el-table-column prop="productName" label="品种"></el-table-column>
									<el-table-column prop="texture" label="材质"></el-table-column>
									<el-table-column prop="standard" label="规格"></el-table-column>
									<el-table-column prop="price" label="结算价格"></el-table-column>
									<el-table-column prop="settlementMode" label="结算方式"></el-table-column>
									<el-table-column prop="dataDate" label="日期"></el-table-column>
								</el-table>
								<el-pagination style="margin-top: 20px;" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="current_page" :page-size="page_num" layout="total, prev, pager, next, jumper" :total="total_num"></el-pagination>
							</template>
							<template v-else-if="count=='905'">
								<el-form :inline="true" :model="search_form_hg_scj" class="demo-form-inline" size="small" style="background-color: #FFFFFF;padding: 20px;border-bottom: solid 1px #e6e6e6;">
									<el-form-item label="品名: ">
										<el-select v-model="search_form_hg_scj.pinming" filterable clearable placeholder="" >
											<el-option v-for="(item,index) in search_form_hg_scj.pinmingList" :key="item.productId" :label="item.productName" :value="item.productId"></el-option>
										</el-select>
									</el-form-item>
									<el-form-item label="价格形式: ">
										<el-select v-model="search_form_hg_scj.jiagexingshi" filterable clearable placeholder="" >
											<el-option v-for="(item,index) in search_form_hg_scj.jiagexingshiList" :key="item.key" :label="item.val" :value="item.key"></el-option>
										</el-select>
									</el-form-item>
									<template>
										<el-form-item label="市场: ">
											<el-select v-model="search_form_hg_scj.shichang" filterable clearable placeholder="" >
												<el-option v-for="(item,index) in search_form_hg_scj.shichangList" :key="item.marketAreaId" :label="item.marketName" :value="item.marketAreaId"></el-option>
											</el-select>
										</el-form-item>
									</template>
									<template>
										<el-form-item label="产地: ">
											<el-select v-model="search_form_hg_scj.chandi" filterable clearable placeholder="" >
												<el-option v-for="(item,index) in search_form_hg_scj.chandiList" :key="item.originAreaId" :label="item.originName" :value="item.originAreaId"></el-option>
											</el-select>
										</el-form-item>
									</template>
									<el-form-item label="日期: ">
										<el-date-picker v-model="search_form_hg_scj.date" type="date" format="yyyy年MM月dd日" value-format="yyyy-MM-dd" placeholder="日期"></el-date-picker>
									</el-form-item>
									<el-form-item>
										<el-button type="primary" @click="current_page=1;page_num=11;searchForm_hg_scj()" icon="el-icon-search">查询</el-button>
									</el-form-item>
								</el-form>
								
								<el-table :data="tableData" :header-cell-style="{'color':'#333333','font-weight':'700','background-color': '#f5fafe'}" style="font-size: 14px;" v-loading="loading" element-loading-text="加载中" element-loading-spinner="el-icon-loading">
									<el-table-column prop="productName" label="品名"></el-table-column>
									<el-table-column prop="price" label="价格"></el-table-column>
									<el-table-column prop="chg" label="涨跌"></el-table-column>
									<el-table-column prop="taste" label="品位"></el-table-column>
									<el-table-column prop="priceFormName" label="价格形式"></el-table-column>
									<el-table-column prop="marketName" label="市场"></el-table-column>
									<el-table-column prop="originName" label="产地"></el-table-column>
									<el-table-column prop="dataDate" label="更新日期"></el-table-column>
								</el-table>
								<el-pagination style="margin-top: 20px;" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="current_page" :page-size="page_num" layout="total, prev, pager, next, jumper" :total="total_num"></el-pagination>
							</template>
							<template v-else>
								<el-form :inline="true" :model="search_form_hg_scj" class="demo-form-inline" size="small" style="background-color: #FFFFFF;padding: 20px;border-bottom: solid 1px #e6e6e6;">
									<template v-if="count=='500'||count=='000'||count=='100'||count=='300'||count=='400'||count=='001'||count=='401'">
										<el-form-item label="地区: ">
											<el-select v-model="search_form_hg_scj.area" filterable clearable placeholder="" >
												<el-option key="1" label="东北" value="1"></el-option>
												<el-option key="2" label="西北" value="2"></el-option>
												<el-option key="3" label="中南" value="3"></el-option>
												<el-option key="4" label="西南" value="4"></el-option>
												<el-option key="5" label="华北" value="5"></el-option>
												<el-option key="6" label="华东" value="6"></el-option>
											</el-select>
										</el-form-item>
									</template>
									<el-form-item label="品名: ">
										<el-select v-model="search_form_hg_scj.pinming" filterable clearable placeholder="" >
											<el-option v-for="(item,index) in search_form_hg_scj.pinmingList" :key="item.productId" :label="item.productName" :value="item.productId"></el-option>
										</el-select>
									</el-form-item>
									<template v-if="count!='800'&&count!='1101'">
										<el-form-item label="材质: ">
											<el-select v-model="search_form_hg_scj.caizhi" filterable clearable placeholder="" >
												<el-option v-for="(item,index) in search_form_hg_scj.caizhiList" :key="item" :label="item" :value="item"></el-option>
											</el-select>
										</el-form-item>
									</template>
									<el-form-item label="规格: ">
										<el-select v-model="search_form_hg_scj.guige" filterable clearable placeholder="" >
											<el-option v-for="(item,index) in search_form_hg_scj.guigeList" :key="item" :label="item" :value="item"></el-option>
										</el-select>
									</el-form-item>
									<el-form-item label="价格形式: ">
										<el-select v-model="search_form_hg_scj.jiagexingshi" filterable clearable placeholder="" >
											<el-option v-for="(item,index) in search_form_hg_scj.jiagexingshiList" :key="item.key" :label="item.val" :value="item.key"></el-option>
										</el-select>
									</el-form-item>
									<el-form-item label="企业: ">
										<el-select v-model="search_form_hg_scj.qiye" filterable clearable placeholder="" >
											<el-option v-for="(item,index) in search_form_hg_scj.qiyeList" :key="item.key" :label="item.val" :value="item.key"></el-option>
										</el-select>
									</el-form-item>
									<template v-if="count=='500'||count=='000'||count=='100'||count=='300'||count=='400'||count=='200'||count=='800'||count=='603'||count=='1103'||count=='1003'||count=='1101'">
										<el-form-item label="市场: ">
											<el-select v-model="search_form_hg_scj.shichang" filterable clearable placeholder="" >
												<el-option v-for="(item,index) in search_form_hg_scj.shichangList" :key="item.marketAreaId" :label="item.marketName" :value="item.marketAreaId"></el-option>
											</el-select>
										</el-form-item>
									</template>
									<template v-if="count=='501'||count=='701'||count=='001'||count=='401'||count=='101'||count=='1101'||count=='201'||count=='800'||count=='304'">
										<el-form-item label="产地: ">
											<el-select v-model="search_form_hg_scj.chandi" filterable clearable placeholder="" >
												<el-option v-for="(item,index) in search_form_hg_scj.chandiList" :key="item.originAreaId" :label="item.originName" :value="item.originAreaId"></el-option>
											</el-select>
										</el-form-item>
									</template>
									<el-form-item label="日期: ">
										<el-date-picker v-model="search_form_hg_scj.date" type="date" format="yyyy年MM月dd日" value-format="yyyy-MM-dd" placeholder="日期"></el-date-picker>
									</el-form-item>
									<el-form-item>
										<el-button type="primary" @click="current_page=1;page_num=11;searchForm_hg_scj()" icon="el-icon-search">查询</el-button>
									</el-form-item>
								</el-form>
								<el-table :data="tableData" :header-cell-style="{'color':'#333333','font-weight':'700','background-color': '#f5fafe'}" style="font-size: 14px;" v-loading="loading" element-loading-text="加载中" element-loading-spinner="el-icon-loading">
								    <el-table-column prop="productName" label="品名"></el-table-column>
									<el-table-column width="90" prop="price" label="价格(元/吨)"></el-table-column>
									<!-- <el-table-column width="60" prop="unitName" label="单位"></el-table-column> -->
									<el-table-column width="60" prop="chg" label="涨跌"></el-table-column>
									<template v-if="count!='800'">
									    <el-table-column prop="texture" label="材质"></el-table-column>
									</template>
									<el-table-column prop="standard" label="规格"></el-table-column>
									<el-table-column prop="priceFormName" label="价格形式"></el-table-column>
									<template  v-if="count=='500'||count=='000'||count=='100'||count=='300'||count=='400'||count=='200'||count=='800'||count=='603'||count=='1103'||count=='1003'||count=='1101'">
									    <el-table-column prop="marketName" label="市场"></el-table-column>
									</template>
									<template  v-if="count=='501'||count=='701'||count=='001'||count=='401'||count=='101'||count=='1101'||count=='201'||count=='800'||count=='304'">
									    <el-table-column prop="originName" label="产地"></el-table-column>
									</template>
									<el-table-column prop="enterpriseName" label="企业"></el-table-column>
									<el-table-column width="60" prop="dataDate" label="日期">
										<template slot-scope="scope">
											{{scope.row.dataDate.substr(5)}}
										</template>
									</el-table-column>
								</el-table>
								<el-pagination style="margin-top: 20px;" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="current_page" :page-size="page_num" layout="total, prev, pager, next, jumper" :total="total_num"></el-pagination>
							</template>
						</template>

                    </div>
                </el-col>
                <el-col :span="8">
                    <div class="grid-content">
                        <!-- <RecordAnalysis style="margin-bottom: 20px;"></RecordAnalysis> -->
						<div class="bgWhite p15" style="padding-bottom: 20px; height: 310px;margin-bottom: 20px;">
						    <h4 class="fontNormal font16" style="margin-bottom: 10px">报告 · 市场分析</h4>
						    <div class="mw-table-line">
						        <div class="mw-table-row pointer" v-for="(item, index) in report_list" :key="index" @click="goReportPage(item.reportId)">
						            <div>{{ item.reportTitle }}</div>
						            <div>{{ item.reportDate }}</div>
						        </div>
						        
						    </div>
						</div>
                        <div v-if="adIDsIndex[1]['list']">
                            <a v-for="(item, index) in adIDsIndex[1]['list']" :key="index" :href="item.adLink" target="_blank">
                                <img :src="item.adPicturePath" alt="" class="w100">
                            </a>
                        </div>
                        <FastNewsControl style="margin-top: 20px;"></FastNewsControl>
                        <HotRecord style="margin-top: 20px;"></HotRecord>
                    </div>
                </el-col>
            </el-row>
        </article>
        <ConcatsControl></ConcatsControl>
    </div>
</template>

<script>
import MapControl from '../../templates/mapControl'
import RecordAnalysis from '../../templates/recordAnalysis'
import HotRecord from '../../templates/hotRecord'
import ConcatsControl from '../../templates/concatsControl'
import FastNewsControl from '../../templates/fastNewsControl'
import $ from 'jquery'
import '../../../node_modules/echarts/map/js/china.js'
import { baseUrl, adIDs, getQueryString } from '../../assets/js/common'
import { MapOption, LineOption_2 } from '../../assets/js/options'

export default {
    name: 'allPrice',
    components: { MapControl, RecordAnalysis, HotRecord, ConcatsControl, FastNewsControl },
    data () {
        return {
			search_form_hg_scj:{
				date:"",
				area:"",
				pinming:"",
				pinmingList:[],
				guige:"",
				guigeList:[],
				caizhi:"",
				caizhiList:[],
				jiagexingshi:"",
				jiagexingshiList:[],
				qiye:"",
				qiyeList:[],
				shichang:"",
				shichangList:[],
				chandi:"",
				chandiList:[]
			},
			count:"000",
			current_page: 1,
			page_num: 11,
			total_num: 0,
			tableData:[],
			default_active:"",
			activeMenuIndex1:"A_0",
			activeMenuIndex2:"B_0",
			activeMenuIndex3:"C_0",
			productTag_list: [],
			adIDsIndex: [{
			    name: 'jzjA',
			    id: adIDs['jzjA'],
			    list: []
			},{
			    name: 'jzjC',
			    id: adIDs['jzjC'],
			    list: []
			},{
			    name: 'indexRight1',
			    id: adIDs['indexRight1'],
			    list: []
			},{
			    name: 'jzj44',
			    id: adIDs['jzj44'],
			    list: []
			}],
			scj_show:true,
			ccj_show:true,
			jsj_show:true,
			cgj_show:true,
			zdj_show:true,
			gkxhj_show:true,
			loading:false,
			report_list: [],
			hasReport: false
        }
    },
    mounted () {
        // 初始化内容
        this.findAllProductTag();
        this.getAdByAdp();
		this.findReportSortByUserFormat();
		this.findNaTree();
    },
    methods: {
		// 获取权限
		findNaTree () {
			const self = this;
			const token_cyw = self.$cookies.get('token_cyw');
			let url = ``;
			if (token_cyw) {
				self.$get(`${baseUrl.business}/api/user/userByToken/${token_cyw}`, {}).then(res_1 => {
					if (res_1.status == 200) {
						url = `${baseUrl.cyw}/navigation/findNaTree?visitLimit=Y`;
					} else {
						url = `${baseUrl.cyw}/navigation/findNaTree?visitLimit=N`;
					}
					self.$get(url, {}).then(res => {
						if (res.code == 0) {
							res.data.forEach((item, index) => {
								if (item.navigationName == '研报') {
									self.hasReport = true;
								}
							})
						} else {
							self.hasReport = false;
						}
					}).catch(err => {})
				})
			} else {
				url = `${baseUrl.cyw}/navigation/findNaTree?visitLimit=N`;
				self.$get(url, {}).then(res => {
					if (res.code == 0) {
						self.submenu_list_1 = [];
						res.data.forEach((item, index) => {
							if (item.navigationName == '研报') {
								self.hasReport = true;
							}
						})
					} else {
						self.hasReport = false;
					}
				}).catch(err => {
				})
			}
		},
		
		findReportSortByUserFormat () {
			const self = this;
			var reportSort="";
			if(this.activeMenuIndex1=="A_0"){
				reportSort="2018092504095719904667";
			}
			if(this.activeMenuIndex1=="A_1"){
				reportSort="2018092503092219886362";
			}
			if(this.activeMenuIndex1=="A_2"){
				reportSort="2018092504095819904669";
			}
			if(this.activeMenuIndex1=="A_3"){
				reportSort="2018092504093519904668";
			}
			if(this.activeMenuIndex1=="A_4"){
				reportSort="2018092504090219904737";
			}
			if(this.activeMenuIndex1=="A_5"){
				reportSort="2018092504095319904738";
			}
			if(this.activeMenuIndex1=="A_6"){
				reportSort="2018092504093019904665";
			}
			if(this.activeMenuIndex1=="A_7"){
				reportSort="2018092504092719904666";
			}
			if(this.activeMenuIndex1=="A_8"){
				reportSort="2018092503093419904413";
			}
			if(this.activeMenuIndex1=="A_9"){
				reportSort="2018092503093419904413";
			}
			if(this.activeMenuIndex1=="A_10"){
				reportSort="2018092504092919904664";
			}
			if(this.activeMenuIndex1=="A_11"){
				reportSort="2018092504092919904664";
			}
			self.$post(`${baseUrl.online}/industria/report/searchReport/1/7`, {reportSort: reportSort}).then(res => {
				if (res.code == 0) {
					self.report_list = res.data;
				} else {
					self.$message.error(res.message);
				}
			}).catch(err => {
				self.$message.error('未获取到报告分类信息');
			})
		},
		/* ***** 获取报告分析 - 唐宋100指数（周）报告  end ******************************** */
		goReportPage (id) {
			if (this.hasReport) {
				this.$router.push(`/home/reportDetail/${id}`)
			} else {
				this.$message({
					message: '登录即可查看全部研报信息',
					type: 'warning'
				})
			}
		},
		handleSelectMenu1(key, keyPath){
			this.activeMenuIndex1=key;
			this.activeMenuIndex2="B_0";
			this.activeMenuIndex3="C_0";
			this.pageChange(key);
			this.findReportSortByUserFormat();
		},
		handleSelectMenu2(key, keyPath){
			this.activeMenuIndex2=key;
			this.activeMenuIndex3="C_0";
			this.pageChange(key);
		},
		handleSelectMenu3(key, keyPath){
			this.activeMenuIndex3=key;
			this.pageChange(key);
		},
		pageChange(key){
			console.log(key);
			this.search_form_hg_scj.date="";
			this.search_form_hg_scj.area="";
			this.search_form_hg_scj.pinming="";
			this.search_form_hg_scj.pinmingList=[];
			this.search_form_hg_scj.guige="";
			this.search_form_hg_scj.guigeList=[];
			this.search_form_hg_scj.caizhi="";
			this.search_form_hg_scj.caizhiList=[];
			this.search_form_hg_scj.jiagexingshi="";
			this.search_form_hg_scj.jiagexingshiList=[];
			this.search_form_hg_scj.qiye="";
			this.search_form_hg_scj.qiyeList=[];
			this.search_form_hg_scj.shichang="";
			this.search_form_hg_scj.shichangList=[];
			this.search_form_hg_scj.chandi="";
			this.search_form_hg_scj.chandiList=[];
			if(this.productTag_list[this.activeMenuIndex1.substr(2)].basePriceName.indexOf("螺纹钢")>=0){
				console.log("螺纹钢");
				if(this.activeMenuIndex2=="B_0"){
					console.log("螺纹钢价格");
					this.scj_show=true;
					this.ccj_show=true;
					this.jsj_show=true;
					this.cgj_show=false;
					this.zdj_show=false;
					this.gkxhj_show=false;
					if(this.activeMenuIndex3=="C_0"){
						console.log("螺纹钢市场价");
						this.count="000";
						this.searchForm_hg_scj();
					}else if(this.activeMenuIndex3=="C_1"){
						console.log("螺纹钢出厂价");
						this.count="001";
						this.searchForm_hg_scj();
					}else if(this.activeMenuIndex3=="C_2"){
						console.log("螺纹钢结算价");
						this.count="002";
						this.searchForm_hg_scj();
					}else{
						this.activeMenuIndex3="C_0";
						console.log("螺纹钢市场价");
						this.count="000";
						this.searchForm_hg_scj();
					}
				}
			}
			if(this.productTag_list[this.activeMenuIndex1.substr(2)].basePriceName.indexOf("线材")>=0){
				console.log("线材");
				if(this.activeMenuIndex2=="B_0"){
					console.log("线材价格");
					this.scj_show=true;
					this.ccj_show=true;
					this.jsj_show=true;
					this.cgj_show=false;
					this.zdj_show=false;
					this.gkxhj_show=false;
					if(this.activeMenuIndex3=="C_0"){
						console.log("线材市场价");
						this.count="100";
						this.searchForm_hg_scj();
					}else if(this.activeMenuIndex3=="C_1"){
						console.log("线材出厂价");
						this.count="101";
						this.searchForm_hg_scj();
					}else if(this.activeMenuIndex3=="C_2"){
						console.log("线材结算价");
						this.count="102";
						this.searchForm_hg_scj();
					}else{
						this.activeMenuIndex3="C_0";
						console.log("线材市场价");
						this.count="100";
						this.searchForm_hg_scj();
					}
				}
			}
			if(this.productTag_list[this.activeMenuIndex1.substr(2)].basePriceName.indexOf("带钢")>=0){
				console.log("带钢");
				if(this.activeMenuIndex2=="B_0"){
					console.log("带钢价格");
					this.scj_show=true;
					this.ccj_show=true;
					this.jsj_show=true;
					this.cgj_show=false;
					this.zdj_show=false;
					this.gkxhj_show=false;
					if(this.activeMenuIndex3=="C_0"){
						console.log("带钢市场价");
						this.count="200";
						this.searchForm_hg_scj();
					}else if(this.activeMenuIndex3=="C_1"){
						console.log("带钢出厂价");
						this.count="201";
						this.searchForm_hg_scj();
					}else if(this.activeMenuIndex3=="C_2"){
						console.log("带钢结算价");
						this.count="202";
						this.searchForm_hg_scj();
					}else{
						this.activeMenuIndex3="C_0";
						console.log("带钢市场价");
						this.count="200";
						this.searchForm_hg_scj();
					}
				}
			}
			if(this.productTag_list[this.activeMenuIndex1.substr(2)].basePriceName.indexOf("板材")>=0){
				console.log("板材");
				if(this.activeMenuIndex2=="B_0"){
					console.log("板材价格");
					this.scj_show=true;
					this.ccj_show=false;
					this.jsj_show=true;
					this.cgj_show=false;
					this.zdj_show=true;
					this.gkxhj_show=false;
					if(this.activeMenuIndex3=="C_0"){
						console.log("板材市场价");
						this.count="300";
						this.searchForm_hg_scj();
					}else if(this.activeMenuIndex3=="C_2"){
						console.log("板材结算价");
						this.count="302";
						this.searchForm_hg_scj();
					}else if(this.activeMenuIndex3=="C_4"){
						console.log("板材指导价");
						this.count="304";
						this.searchForm_hg_scj();
					}else{
						this.activeMenuIndex3="C_0";
						console.log("板材市场价");
						this.count="300";
						this.searchForm_hg_scj();
					}
				}
			}
			if(this.productTag_list[this.activeMenuIndex1.substr(2)].basePriceName.indexOf("型钢")>=0){
				console.log("型钢");
				if(this.activeMenuIndex2=="B_0"){
					console.log("型钢价格");
					this.scj_show=true;
					this.ccj_show=true;
					this.jsj_show=false;
					this.cgj_show=false;
					this.zdj_show=false;
					this.gkxhj_show=false;
					if(this.activeMenuIndex3=="C_0"){
						console.log("型钢市场价");
						this.count="400";
						this.searchForm_hg_scj();
					}else if(this.activeMenuIndex3=="C_1"){
						console.log("型钢出厂价");
						this.count="401";
						this.searchForm_hg_scj();
					}else{
						this.activeMenuIndex3="C_0";
						console.log("型钢市场价");
						this.count="400";
						this.searchForm_hg_scj();
					}
				}
			}
			if(this.productTag_list[this.activeMenuIndex1.substr(2)].basePriceName.indexOf("管材")>=0){
				console.log("管材");
				if(this.activeMenuIndex2=="B_0"){
					console.log("管材价格");
					this.scj_show=true;
					this.ccj_show=true;
					this.jsj_show=false;
					this.cgj_show=false;
					this.zdj_show=false;
					this.gkxhj_show=false;
					if(this.activeMenuIndex3=="C_0"){
						console.log("管材市场价");
						this.count="500";
						this.searchForm_hg_scj();
					}else if(this.activeMenuIndex3=="C_1"){
						console.log("管材出厂价");
						this.count="501";
						this.searchForm_hg_scj();
					}else{
						this.activeMenuIndex3="C_0";
						console.log("管材市场价");
						this.count="500";
						this.searchForm_hg_scj();
					}
				}
			}
			if(this.productTag_list[this.activeMenuIndex1.substr(2)].basePriceName.indexOf("废钢")>=0){
				console.log("废钢");
				if(this.activeMenuIndex2=="B_0"){
					console.log("废钢价格");
					this.scj_show=false;
					this.ccj_show=false;
					this.jsj_show=false;
					this.cgj_show=true;
					this.zdj_show=false;
					this.gkxhj_show=false;
					if(this.activeMenuIndex3=="C_3"){
						console.log("废钢采购价");
						this.count="603";
						this.searchForm_hg_scj();
					}else{
						this.activeMenuIndex3="C_3";
						console.log("废钢采购价");
						this.count="603";
						this.searchForm_hg_scj();
					}
				}
			}
			if(this.productTag_list[this.activeMenuIndex1.substr(2)].basePriceName.indexOf("钢坯")>=0){
				console.log("钢坯");
				if(this.activeMenuIndex2=="B_0"){
					console.log("钢坯价格");
					this.scj_show=false;
					this.ccj_show=true;
					this.jsj_show=false;
					this.cgj_show=false;
					this.zdj_show=false;
					this.gkxhj_show=false;
					if(this.activeMenuIndex3=="C_1"){
						console.log("钢坯出厂价");
						this.count="701";
						this.searchForm_hg_scj();
					}else{
						this.activeMenuIndex3="C_1";
						console.log("钢坯出厂价");
						this.count="701";
						this.searchForm_hg_scj();
					}
				}
			}
			if(this.productTag_list[this.activeMenuIndex1.substr(2)].basePriceName.indexOf("国产矿")>=0){
				console.log("国产矿");
				if(this.activeMenuIndex2=="B_0"){
					console.log("国产矿价格");
					this.scj_show=true;
					this.ccj_show=false;
					this.jsj_show=false;
					this.cgj_show=false;
					this.zdj_show=false;
					this.gkxhj_show=false;
					if(this.activeMenuIndex3=="C_0"){
						console.log("国产矿市场价");
						this.count="800";
						this.searchForm_hg_scj();
					}else{
						this.activeMenuIndex3="C_0";
						console.log("国产矿市场价");
						this.count="800";
						this.searchForm_hg_scj();
					}
				}
			}
			if(this.productTag_list[this.activeMenuIndex1.substr(2)].basePriceName.indexOf("进口矿")>=0){
				console.log("进口矿");
				if(this.activeMenuIndex2=="B_0"){
					console.log("进口矿价格");
					this.scj_show=false;
					this.ccj_show=false;
					this.jsj_show=false;
					this.cgj_show=false;
					this.zdj_show=false;
					this.gkxhj_show=true;
					if(this.activeMenuIndex3=="C_5"){
						console.log("进口矿港口现货价");
						this.count="905";
						this.searchForm_hg_scj();
					}else{
						this.activeMenuIndex3="C_5";
						console.log("进口矿港口现货价");
						this.count="905";
						this.searchForm_hg_scj();
					}
				}
			}
			if(this.productTag_list[this.activeMenuIndex1.substr(2)].basePriceName.indexOf("煤炭")>=0){
				console.log("煤炭");
				if(this.activeMenuIndex2=="B_0"){
					console.log("煤炭价格");
					this.scj_show=false;
					this.ccj_show=false;
					this.jsj_show=false;
					this.cgj_show=true;
					this.zdj_show=false;
					this.gkxhj_show=false;
					if(this.activeMenuIndex3=="C_3"){
						console.log("煤炭采购价");
						this.count="1003";
						this.searchForm_hg_scj();
					}else{
						this.activeMenuIndex3="C_3";
						console.log("煤炭采购价");
						this.count="1003";
						this.searchForm_hg_scj();
					}
				}
			}
			if(this.productTag_list[this.activeMenuIndex1.substr(2)].basePriceName.indexOf("焦炭")>=0){
				console.log("焦炭");
				if(this.activeMenuIndex2=="B_0"){
					console.log("焦炭价格");
					this.scj_show=false;
					this.ccj_show=true;
					this.jsj_show=false;
					this.cgj_show=true;
					this.zdj_show=false;
					this.gkxhj_show=false;
					if(this.activeMenuIndex3=="C_1"){
						console.log("焦炭出厂价");
						this.count="1101";
						this.searchForm_hg_scj();
					}else if(this.activeMenuIndex3=="C_3"){
						console.log("焦炭采购价");
						this.count="1103";
						this.searchForm_hg_scj();
					}else{
						this.activeMenuIndex3="C_1";
						console.log("焦炭出厂价");
						this.count="1101";
						this.searchForm_hg_scj();
					}
				}
			}
			if(this.count=="002"||this.count=="102"||this.count=="302"||this.count=="202"){
				
			}else{
				if(this.count!="905"){
				    this.getqiye_hg_scj();
				    this.getcaizhi_hg_scj();
				    this.getguige_hg_scj();
				}
				this.getjiagexingshi_hg_scj();
				this.getpinming_hg_scj();
				if(this.count=="500"||this.count=="000"||this.count=="100"||this.count=="300"||this.count=="400"||this.count=="200"||this.count=="800"||this.count=="603"||this.count=="1103"||this.count=="1003"||this.count=="905"||this.count=="1101"){
					this.getshichang_hg_scj();
				}
				if(this.count=="501"||this.count=="701"||this.count=="001"||this.count=="401"||this.count=="101"||this.count=="1101"||this.count=="201"||this.count=="800"||this.count=="304"||this.count=="905"){
					this.getchandi_hg_scj();
				}
			}
		},
		getqiye_hg_scj () {
		    var self = this;
			var myDate = new Date();
			var year=myDate.getFullYear();
			var month=myDate.getMonth()+1; 
			month =(month<10 ? "0"+month:month);
			var day = myDate.getDate();
			day = (day < 10 ? "0" + day : day);
			var url="";
			if(this.count=="000"){
				url="http://118.126.142.187:8088/online/screwMarket/findEnterpriseList?beginDate=2018-01-01&endDate="+year+"-"+month+""+day;
			}
			if(this.count=="001"){
				url="http://118.126.142.187:8088/online/screwExFactory/selectEnterpriseList?beginDate=2018-01-01&endDate="+year+"-"+month+""+day;
			}
			if(this.count=="100"){
				url="http://118.126.142.187:8088/online/wirerodMarket/findEnterpriseList?beginDate=2018-01-01&endDate="+year+"-"+month+""+day;
			}
			if(this.count=="101"){
				url="http://118.126.142.187:8088/online/wirerodExFactory/selectEnterpriseList?beginDate=2018-01-01&endDate="+year+"-"+month+""+day;
			}
			if(this.count=="200"){
				url="http://118.126.142.187:8088/online/marketprice/findEnterpriseList?beginDate=2018-01-01&endDate="+year+"-"+month+""+day;
			}
			if(this.count=="201"){
				url="http://118.126.142.187:8088/online/exprice/selectEnterpriseList?beginDate=2018-01-01&endDate="+year+"-"+month+""+day;
			}
			if(this.count=="300"){
				url="http://118.126.142.187:8088/online/paletMarket/findEnterpriseList?beginDate=2018-01-01&endDate="+year+"-"+month+""+day;
			}
			if(this.count=="304"){
				url="https://service.chinatsi.net/api_v3/plate_brand_dict";
			}
			if(this.count=="400"){
				url="http://118.126.142.187:8088/online/sectionMarket/findEnterpriseList?beginDate=2018-01-01&endDate="+year+"-"+month+""+day;
			}
			if(this.count=="401"){
				url="http://118.126.142.187:8088/online/sectionExFactory/selectEnterpriseList?isprice=N&beginDate=2018-01-01&endDate="+year+"-"+month+""+day;
			}
			if(this.count=="500"){
				url="http://118.126.142.187:8088/online/pipeMarket/findEnterpriseList?beginDate=2018-01-01&endDate="+year+"-"+month+""+day;
			}
			if(this.count=="501"){
				url="http://118.126.142.187:8088/online/pipeExFactory/selectEnterpriseList?type=1&beginDate=2018-01-01&endDate="+year+"-"+month+""+day;
			}
			if(this.count=="603"){
				url="http://118.126.142.187:8088/online/scrapPurchase/findEnterpriseList?type=1";
			}
			if(this.count=="701"){
				url="http://118.126.142.187:8088/online/billetExFactory/selectEnterpriseList?beginDate=2018-01-01&endDate="+year+"-"+month+""+day;
			}
			if(this.count=="800"){
				url="http://118.126.142.187:8088/online/domesticMarketPrice/findEnterpriseList";
			}
			if(this.count=="1101"){
				url="http://118.126.142.187:8088/online/cokeExFactory/selectEnterpriseList?type=1&beginDate=2018-01-01&endDate="+year+"-"+month+""+day;
			}
			if(this.count=="1003"){
				url="http://118.126.142.187:8088/online/cokePurchase/findEnterpriseList?type=2";
			}
			if(this.count=="1103"){
				url="http://118.126.142.187:8088/online/cokePurchase/findEnterpriseList?type=1";
			}
		    self.$get(url, {}).then(res => {
		        if (res.code == 0) {
					if(self.count=="500"||self.count=="000"||self.count=="100"||self.count=="300"||self.count=="400"||self.count=="200"||self.count=="800"||self.count=="603"||self.count=="1103"||self.count=="1003"){
		                self.search_form_hg_scj.qiyeList = res.data;
					}
					if(self.count=="501"||self.count=="701"||self.count=="001"||self.count=="401"||self.count=="101"||self.count=="1101"||self.count=="201"){
						var temparr=[];
						res.data.forEach((item, index) => {
							temparr.push({
								"key":item.enterpriseId,
								"val":item.enterpriseName
							});
						})
						self.search_form_hg_scj.qiyeList = temparr;
					}
		        }
				if(res.code=="ok"){
					if(self.count=="304"){
						var temparr=[];
						res.data.forEach((item, index) => {
							temparr.push({
								"key":item.data,
								"val":item.data
							});
						})
						self.search_form_hg_scj.qiyeList = temparr;
					}
				}
		    })
		},
		getcaizhi_hg_scj () {
		    var self = this;
			var url="";
			if(this.count=="800"||this.count=="603"||this.count=="1103"||this.count=="1003"||this.count=="1101"){
				return;
			}
			if(this.count=="000"){
				url="http://118.126.142.187:8088/online/screwMarket/findTextureList";
			}
			if(this.count=="001"){
				url="http://118.126.142.187:8088/online/screwMarket/findTextureList";
			}
			if(this.count=="100"){
				url="http://118.126.142.187:8088/online/wirerodMarket/findTextureList";
			}
			if(this.count=="101"){
				url="http://118.126.142.187:8088/online/wirerodExFactory/findTextureList";
			}
			if(this.count=="200"){
				url="http://118.126.142.187:8088/online/marketprice/findTextureList";
			}
			if(this.count=="201"){
				url="http://118.126.142.187:8088/online/exprice/findTextureList";
			}
			if(this.count=="300"){
				url="http://118.126.142.187:8088/online/paletMarket/findTextureList";
			}
			if(this.count=="304"){
				url="https://service.chinatsi.net/api_v3/plate_cz_dict";
			}
			if(this.count=="400"){
				url="http://118.126.142.187:8088/online/sectionMarket/findTextureList";
			}
			if(this.count=="401"){
				url="http://118.126.142.187:8088/online/sectionExFactory/findTextureList";
			}
			if(this.count=="500"){
				url="http://118.126.142.187:8088/online/pipeMarket/findTextureList";
			}
			if(this.count=="501"){
				url="http://118.126.142.187:8088/online/pipeExFactory/findTextureList";
			}
			if(this.count=="701"){
				url="http://118.126.142.187:8088/online/billetExFactory/findTextureList";
			}
		    self.$get(url, {}).then(res => {
		        if (res.code == 0) {
		            self.search_form_hg_scj.caizhiList = res.data;
		        }
				if(res.code=="ok"){
					if(self.count=="304"){
						var temparr=[];
						res.data.forEach((item, index) => {
							temparr.push(item.data);
						})
						self.search_form_hg_scj.caizhiList = temparr;
					}
				}
		    })
		},
		getguige_hg_scj () {
		    var self = this;
			var url="";
			if(this.count=="000"){
				url="http://118.126.142.187:8088/online/screwMarket/findStandardList";
			}
			if(this.count=="001"){
				url="http://118.126.142.187:8088/online/screwMarket/findStandardList";
			}
			if(this.count=="100"){
				url="http://118.126.142.187:8088/online/wirerodMarket/findStandardList";
			}
			if(this.count=="101"){
				url="http://118.126.142.187:8088/online/wirerodExFactory/findStandardList";
			}
			if(this.count=="200"){
				url="http://118.126.142.187:8088/online/marketprice/findStandardList";
			}
			if(this.count=="201"){
				url="http://118.126.142.187:8088/online/exprice/findStandardList";
			}
			if(this.count=="300"){
				url="http://118.126.142.187:8088/online/paletMarket/findStandardList";
			}
			if(this.count=="304"){
				url="https://service.chinatsi.net/api_v3/plate_gg_dict";
			}
			if(this.count=="400"){
				url="http://118.126.142.187:8088/online/sectionMarket/findStandardList";
			}
			if(this.count=="401"){
				url="http://118.126.142.187:8088/online/sectionExFactory/findStandardList";
			}
			if(this.count=="500"){
				url="http://118.126.142.187:8088/online/pipeMarket/findStandardList";
			}
			if(this.count=="501"){
				url="http://118.126.142.187:8088/online/pipeExFactory/findStandardList";
			}
			if(this.count=="603"){
				url="http://118.126.142.187:8088/online/scrapPurchase/findStandardList?type=1";
			}
			if(this.count=="701"){
				url="http://118.126.142.187:8088/online/billetExFactory/findStandardList";
			}
			if(this.count=="800"){
				url="http://118.126.142.187:8088/online/domesticMarketPrice/findStandardList";
			}
			if(this.count=="1101"){
				url="http://118.126.142.187:8088/online/cokeExFactory/findStandardList?type=1";
			}
			if(this.count=="1103"){
				url="http://118.126.142.187:8088/online/cokePurchase/findStandardList?type=1";
			}
			if(this.count=="1003"){
				url="http://118.126.142.187:8088/online/cokePurchase/findStandardList?type=2";
			}
		    self.$get(url, {}).then(res => {
		        if (res.code == 0) {
		            self.search_form_hg_scj.guigeList = res.data;
		        }
				if(res.code=="ok"){
					if(self.count=="304"){
						var temparr=[];
						res.data.forEach((item, index) => {
							temparr.push(item.data);
						})
						self.search_form_hg_scj.guigeList = temparr;
					}
				}
		    })
		},
		getjiagexingshi_hg_scj () {
		    var self = this;
			var url="";
			if(this.count=="000"){
				url="http://118.126.142.187:8088/online/screwMarket/findPriceFormList";
			}
			if(this.count=="001"){
				url="http://118.126.142.187:8088/online/screwMarket/findPriceFormList";
			}
			if(this.count=="100"){
				url="http://118.126.142.187:8088/online/wirerodMarket/findPriceFormList";
			}
			if(this.count=="101"){
				url="http://118.126.142.187:8088/online/wirerodExFactory/findPriceFormList";
			}
			if(this.count=="200"){
				url="http://118.126.142.187:8088/online/marketprice/findPriceFormList";
			}
			if(this.count=="201"){
				url="http://118.126.142.187:8088/online/exprice/findPriceFormList";
			}
			if(this.count=="300"){
				url="http://118.126.142.187:8088/online/paletMarket/findPriceFormList";
			}
			if(this.count=="304"){
				url="https://service.chinatsi.net/api_v3/plate_from_dict";
			}
			if(this.count=="400"){
				url="http://118.126.142.187:8088/online/sectionMarket/findPriceFormList";
			}
			if(this.count=="401"){
				url="http://118.126.142.187:8088/online/sectionExFactory/findPriceFormList";
			}
			if(this.count=="500"){
				url="http://118.126.142.187:8088/online/pipeMarket/findPriceFormList";
			}
			if(this.count=="501"){
				url="http://118.126.142.187:8088/online/pipeExFactory/findPriceFormList";
			}
			if(this.count=="603"){
				url="http://118.126.142.187:8088/online/scrapPurchase/findPriceFormList?type=1";
			}
			if(this.count=="701"){
				url="http://118.126.142.187:8088/online/billetExFactory/findPriceFormList";
			}
			if(this.count=="800"){
				url="http://118.126.142.187:8088/online/domesticMarketPrice/findPriceFormList";
			}
			if(this.count=="1101"){
				url="http://118.126.142.187:8088/online/cokeExFactory/findPriceFormList?type=1";
			}
			if(this.count=="1103"){
				url="http://118.126.142.187:8088/online/cokePurchase/findPriceFormList?type=1";
			}
			if(this.count=="1003"){
				url="http://118.126.142.187:8088/online/cokePurchase/findPriceFormList?type=2";
			}
			if(this.count=="905"){
				url="http://118.126.142.187:8088/online/importedPortSpot/findPriceFormList";
			}
		    self.$get(url, {}).then(res => {
		        if (res.code == 0) {
		            self.search_form_hg_scj.jiagexingshiList = res.data;
		        }
				if(res.code=="ok"){
					if(self.count=="304"){
						var temparr=[];
						res.data.forEach((item, index) => {
							temparr.push(item.data);
						})
						self.search_form_hg_scj.jiagexingshiList = temparr;
					}
				}
		    })
		},
		getpinming_hg_scj () {
		    var self = this;
			var url="";
			if(this.count=="000"){
				url="http://118.126.142.187:8088/online/screwBasePrice/findProductList";
			}
			if(this.count=="001"){
				url="http://118.126.142.187:8088/online/screwBasePrice/findProductList";
			}
			if(this.count=="100"){
				url="http://118.126.142.187:8088/online/wirerodMarket/wirerodProductCondition";
			}
			if(this.count=="101"){
				url="http://118.126.142.187:8088/online/wirerodExFactory/exFactoryProductCondition";
			}
			if(this.count=="200"){
				url="http://118.126.142.187:8088/online/marketprice/productCondition";
			}
			if(this.count=="201"){
				url="http://118.126.142.187:8088/online/exprice/productCondition";
			}
			if(this.count=="300"){
				url="http://118.126.142.187:8088/online/paletMarket/plateProductCondition";
			}
			if(this.count=="304"){
				url="https://service.chinatsi.net/api_v3/plate_product_dict";
			}
			if(this.count=="400"){
				url="http://118.126.142.187:8088/online/sectionMarket/sectionProductCondition";
			}
			if(this.count=="401"){
				url="http://118.126.142.187:8088/online/sectionExFactory/exFactoryProductCondition?isprice=N";
			}
			if(this.count=="500"){
				url="http://118.126.142.187:8088/online/pipeMarket/ProductCondition?type=1";
			}
			if(this.count=="501"){
				url="http://118.126.142.187:8088/online/pipeExFactory/exFactoryProductCondition?type=1";
			}
			if(this.count=="603"){
				url="http://118.126.142.187:8088/online/scrapPurchase/ProductCondition?type=1";
			}
			if(this.count=="701"){
				url="http://118.126.142.187:8088/online/billetExFactory/exFactoryProductCondition";
			}
			if(this.count=="800"){
				url="http://118.126.142.187:8088/online/domesticMarketPrice/findProductList";
			}
			if(this.count=="1101"){
				url="http://118.126.142.187:8088/online/cokeExFactory/ProductCondition?type=1";
			}
			if(this.count=="1103"){
				url="http://118.126.142.187:8088/online/cokePurchase/ProductCondition?type=1";
			}
			if(this.count=="1003"){
				url="http://118.126.142.187:8088/online/cokePurchase/ProductCondition?type=2";
			}
			if(this.count=="905"){
				url="http://118.126.142.187:8088/online/importedPortSpot/importedSpotProductCondition";
			}
		    self.$get(url, {}).then(res => {
		        if (res.code == 0) {
					if(self.count=="000"||self.count=="001"||self.count=="800"){
						var temparr=[];
						res.data.forEach((item, index) => {
							temparr.push({
								"productId":item.key,
								"productName":item.val
							});
						})
						self.search_form_hg_scj.pinmingList = temparr;
					}
					if(self.count=="500"||self.count=="501"||self.count=="701"||self.count=="100"||self.count=="300"||self.count=="400"||self.count=="401"||self.count=="200"||self.count=="101"||self.count=="1101"||self.count=="201"||self.count=="603"||self.count=="1103"||self.count=="1003"||self.count=="905"){
						self.search_form_hg_scj.pinmingList = res.data;
					}
		        }
				if(res.code=="ok"){
					if(self.count=="304"){
						var temparr=[];
						res.data.forEach((item, index) => {
							temparr.push(item.data);
						})
						self.search_form_hg_scj.pinmingList = temparr;
					}
				}
		    })
		},
		getshichang_hg_scj () {
		    var self = this;
			var url="";
			if(this.count=="000"){
				url="http://118.126.142.187:8088/online/screwMarket/screwMarketCondition";
			}
			if(this.count=="100"){
				url="http://118.126.142.187:8088/online/wirerodMarket/wirerodMarketCondition";
			}
			if(this.count=="200"){
				url="http://118.126.142.187:8088/online/marketprice/marketCondition";
			}
			if(this.count=="300"){
				url="http://118.126.142.187:8088/online/paletMarket/plateMarketCondition";
			}
			if(this.count=="400"){
				url="http://118.126.142.187:8088/online/sectionMarket/sectionMarketCondition";
			}
			if(this.count=="500"){
				url="http://118.126.142.187:8088/online/pipeMarket/MarketCondition?type=1";
			}
			if(this.count=="603"){
				url="http://118.126.142.187:8088/online/scrapPurchase/MarketCondition?type=1";
			}
			if(this.count=="800"){
				url="http://118.126.142.187:8088/online/domesticMarketPrice/selectMarketCondition";
			}
			if(this.count=="1103"){
				url="http://118.126.142.187:8088/online/cokePurchase/MarketCondition?type=1";
			}
			if(this.count=="1003"){
				url="http://118.126.142.187:8088/online/cokePurchase/MarketCondition?type=2";
			}
			if(this.count=="905"){
				url="http://118.126.142.187:8088/online/importedPortSpot/importedSpotMarketCondition";
			}
			if(this.count=="1101"){
				url="http://118.126.142.187:8088/online/cokeExFactory/MarketCondition?type=1";
			}
		    self.$get(url, {}).then(res => {
		        if (res.code == 0) {
		            self.search_form_hg_scj.shichangList = res.data;
		        }
		    })
		},
		getchandi_hg_scj () {
		    var self = this;
			var url="";
			if(this.count=="001"){
				url="http://118.126.142.187:8088/online/screwExFactory/exFactoryOriginCondition";
			}
			if(this.count=="101"){
				url="http://118.126.142.187:8088/online/wirerodExFactory/exFactoryOriginCondition";
			}
			if(this.count=="201"){
				url="http://118.126.142.187:8088/online/exprice/originCondition";
			}
			if(this.count=="304"){
				url="https://service.chinatsi.net/api_v3/plate_origin_dict";
			}
			if(this.count=="401"){
				url="http://118.126.142.187:8088/online/sectionExFactory/exFactoryOriginCondition?isprice=N";
			}
			if(this.count=="501"){
				url="http://118.126.142.187:8088/online/pipeExFactory/exFactoryOriginCondition?type=1";
			}
			if(this.count=="701"){
				url="http://118.126.142.187:8088/online/billetExFactory/exFactoryOriginCondition";
			}
			if(this.count=="800"){
				url="http://118.126.142.187:8088/online/domesticMarketPrice/selectOriginCondition";
			}
			if(this.count=="1101"){
				url="http://118.126.142.187:8088/online/cokeExFactory/OriginCondition?type=1";
			}
			if(this.count=="905"){
				url="http://118.126.142.187:8088/online/importedPortSpot/findOriginList";
			}
		    self.$get(url, {}).then(res => {
		        if(res.code == 0){
		            self.search_form_hg_scj.chandiList = res.data;
		        }
				if(res.code == "ok"){
					if(self.count=="304"){
						var temparr=[];
						res.data.forEach((item, index) => {
							temparr.push(item.data);
						})
						self.search_form_hg_scj.chandiList = temparr;
					}
				}
		    })
		},
		searchForm_hg_scj(){
			this.loading=true;
			var self = this;
			var myDate2 = new Date();
			var eyear=myDate2.getFullYear();
			var emonth=myDate2.getMonth()+1;
			emonth =(emonth<10 ? "0"+emonth:emonth);
			var eday = myDate2.getDate();
			eday = (eday < 10 ? "0" + eday : eday);
			var edate=eyear+"-"+emonth+"-"+eday;
			var btime = new Date().getTime();
			var myDate1 = new Date(btime - 172800000);//前2天
			var byear=myDate1.getFullYear();
			var bmonth=myDate1.getMonth()+1;
			bmonth =(bmonth<10 ? "0"+bmonth:bmonth);
			var bday = myDate1.getDate();
			bday = (bday < 10 ? "0" + bday : bday);
			var bdate=byear+"-"+bmonth+"-"+bday;
			
			var JSONDATA={};
			if(this.count=="304"){
				JSONDATA["cpage"]=self.current_page;
				JSONDATA["pageSize"]=self.page_num;
				JSONDATA["origin"]=self.search_form_hg_scj.chandi;
				JSONDATA["product_name"]=self.search_form_hg_scj.pinming;
				JSONDATA["texture"]=self.search_form_hg_scj.caizhi;
				JSONDATA["standard"]=self.search_form_hg_scj.guige;
				JSONDATA["priceform"]=self.search_form_hg_scj.jiagexingshi;
				JSONDATA["enterpriseId"]=self.search_form_hg_scj.qiye;
				JSONDATA["sdate"]=bdate;
				JSONDATA["edate"]=edate;
			}else if(this.count=="002"||this.count=="102"||this.count=="302"){
				JSONDATA["cpage"]=self.current_page;
				JSONDATA["pageSize"]=self.page_num;
				if(this.count=="002"){
				    JSONDATA["nodeId"]="0104";
				}
				if(this.count=="102"){
					JSONDATA["nodeId"]="0102";
				}
				if(this.count=="302"){
					JSONDATA["nodeId"]="0501";
				}
			}else if(this.count=="202"){
				JSONDATA["isFlag"]="N";
			}else if(this.count=="905"){
				JSONDATA["cpage"]=self.current_page;
				JSONDATA["pageSize"]=self.page_num;
				JSONDATA["marketId"]=self.search_form_hg_scj.shichang;
				JSONDATA["productId"]=self.search_form_hg_scj.pinming;
				JSONDATA["beginDate"]=bdate;
				JSONDATA["endDate"]=edate;
				JSONDATA["priceFormId"]=self.search_form_hg_scj.jiagexingshi;
				JSONDATA["originId"]=self.search_form_hg_scj.chandi;
			}else{
				JSONDATA["cpage"]=self.current_page;
				JSONDATA["pageSize"]=self.page_num;
				if(this.count=="500"||this.count=="000"||this.count=="100"||this.count=="300"||this.count=="400"||this.count=="200"||this.count=="800"||this.count=="603"||this.count=="1103"||this.count=="1003"||this.count=="1101"){
				    JSONDATA["marketId"]=self.search_form_hg_scj.shichang;
				}
				if(this.count=="501"||this.count=="701"||this.count=="001"||this.count=="401"||this.count=="101"||this.count=="1101"||this.count=="201"||this.count=="800"){
				    JSONDATA["originId"]=self.search_form_hg_scj.chandi;
				}
				JSONDATA["productId"]=self.search_form_hg_scj.pinming;
				if(this.count=="500"||this.count=="501"||this.count=="603"||this.count=="1103"||this.count=="1101"){
				    JSONDATA["type"]=1;
				}
				if(this.count=="1003"){
				    JSONDATA["type"]=2;
				}
				if(this.count=="500"||this.count=="000"||this.count=="100"||this.count=="300"||this.count=="400"||this.count=="001"||this.count=="401"){
				    JSONDATA["areaCode"]=self.search_form_hg_scj.area;
				}
				JSONDATA["rq"]=self.search_form_hg_scj.date;
				if(this.count!="800"&&this.count!="603"&&this.count!="1103"&&this.count!="1003"&&this.count!="1101"){
				    JSONDATA["texture"]=self.search_form_hg_scj.caizhi;
				}
				JSONDATA["standard"]=self.search_form_hg_scj.guige;
				JSONDATA["priceFormId"]=self.search_form_hg_scj.jiagexingshi;
				JSONDATA["enterpriseId"]=self.search_form_hg_scj.qiye;
				JSONDATA["beginDate"]=bdate;
				JSONDATA["endDate"]=edate;
			}
			var url="";
			if(this.count=="002"){
				url="http://118.126.142.187:8088/online/screwSettlement/screwSettleMentList";
			}
			if(this.count=="102"){
				url="http://118.126.142.187:8088/online/wirerodSettlement/wirerodSettleMentList";
			}
			if(this.count=="202"){
				url="http://118.126.142.187:8088/online/settleMentprice/settleMentPrices";
			}
			if(this.count=="302"){
				url="http://118.126.142.187:8088/online/plateSettlement/plateSettleMentList";
			}
			if(this.count=="000"){
				url="http://118.126.142.187:8088/online/industria/screwMarket/screwMarketList";
			}
			if(this.count=="001"){
				url="http://118.126.142.187:8088/online/screwExFactory/exFactoryList";
			}
			if(this.count=="100"){
				url="http://118.126.142.187:8088/online/industria/wirerodMarket/wirerodMarketList";
			}
			if(this.count=="101"){
				url="http://118.126.142.187:8088/online/wirerodExFactory/exFactoryList";
			}
			if(this.count=="200"){
				url="http://118.126.142.187:8088/online/marketprice/marketPrices";
			}
			if(this.count=="201"){
				url="http://118.126.142.187:8088/online/exprice/exprices";
			}
			if(this.count=="300"){
				url="http://118.126.142.187:8088/online/industria/paletMarket/plateMarketList";
			}
			if(this.count=="304"){
				url="https://service.chinatsi.net/api_v3/plate_price";
			}
			if(this.count=="400"){
				url="http://118.126.142.187:8088/online/industria/sectionMarket/sectionMarketList";
			}
			if(this.count=="401"){
				url="http://118.126.142.187:8088/online/sectionExFactory/exFactoryList?isprice=N";
			}
			if(this.count=="500"){
				url="http://118.126.142.187:8088/online/industria/pipeMarket/MarketList";
			}
			if(this.count=="501"){
				url="http://118.126.142.187:8088/online/pipeExFactory/exFactoryList";
			}
			if(this.count=="603"){
				url="http://118.126.142.187:8088/online/scrapPurchase/PurchaseList";
			}
			if(this.count=="701"){
				url="http://118.126.142.187:8088/online/billetExFactory/exFactoryList";
			}
			if(this.count=="800"){
				url="http://118.126.142.187:8088/online/domesticMarketPrice/selectDomesticMarketPriceList";
			}
			if(this.count=="1101"){
				url="http://118.126.142.187:8088/online/cokeExFactory/ExFactoryList";
			}
			if(this.count=="1103"){
				url="http://118.126.142.187:8088/online/cokePurchase/PurchaseList";
			}
			if(this.count=="1003"){
				url="http://118.126.142.187:8088/online/cokePurchase/PurchaseList";
			}
			if(this.count=="905"){
				url="http://118.126.142.187:8088/online/importedPortSpot/importedSpotList?rq=&taste=";
			}
            $.ajax({
                url: url,
                data: JSONDATA,
                type: 'get',
                dataType: 'json',
                success: (res) => {
					self.loading=false;
					if(res.code==0){
					    self.tableData=res.data;
					    self.total_num=res.totalCount;
					}
					if(res.code == "ok"){
						if(self.count=="304"){
							var temparr=[];
							res.data.forEach((item, index) => {
								temparr.push({
									"productName":item.PRODUCT_NAME,
									"price":item.HIGTH_PRICE,
									"unitName":item.UNIT_NAME,
									"chg":item.CHG,
									"texture":item.TEXTURE,
									"standard":item.STANDARD,
									"priceFormName":item.PRICE_FROM_NAME,
									"originName":item.ORIGIN_COUNTRY_NAMES,
									"enterpriseName":item.BRAND_NAME,
									"dataDate":item.DATA_DATE
								});
							})
							self.tableData = temparr;
							self.total_num = res.sum;
						}
					}
					if(res.code!=0&&res.code!="ok"){
						self.tableData=[];
						self.total_num=0;
					}
                },
                error: () => {
					self.tableData=[];
					self.total_num=0;
					self.loading=false;
				}
            })
		},
		handleSizeChange(val) { //每页val条
			this.page_num = val;
			this.searchForm_hg_scj();
		},
		handleCurrentChange(val) { //当前第val页
			this.current_page = val;
			this.searchForm_hg_scj();
		},
        // 获取广告信息
        getAdByAdp () {
            const self = this;
            self.adIDsIndex.forEach((item, index) => {
                self.$get(`${baseUrl.cyw}/industriaAD/getAdByAdp?adpId=${item.id}`, {}).then(res => {
                    if (res.code == 0) {
                        self.adIDsIndex[index]['list'] = res.data;
                    }
                })
            })
        },
        // 广告下滑特效
        ADSlideToggle (imgHeight) {
            $('#arrowAD').css('display', 'none');
            $('#slideAD').animate({'height': imgHeight}, 2000, () => {
                setTimeout (() => {
                    $('#slideAD').animate({'height': '0px'}, 2000, () => {
                        $('#arrowAD').css('display', 'block');
                    });
                }, 2000)
            })
        },
        // 获取所有大产品标识
        findAllProductTag () {
            const self = this;
            self.$get(`${baseUrl.online}/industriaBasePrise/findIndexTopList`, {}).then(res => {
                if (res.code == 0) {
                    self.productTag_list = res.data;
					self.default_active=getQueryString("tag");
					self.activeMenuIndex1=getQueryString("tag");
					self.pageChange(getQueryString("tag"));
                } else {
                    // self.$message.error(res.message);
                }
            }).catch(err => {
                // self.$message.error('未获取到分类信息')
            })
        }
    }
}
</script>
<style scoped>
    @import url('allPrice.css');
</style>